export default __webpack_public_path__ + "static/media/location_preview_farmers_market.74eca085.svg";